import {Component} from "inferno";
import {Button} from "inferno-bootstrap";
import {AppState} from "../../../../services/configuration";
import {Entity, IChatMessage} from "../../../../utils/types";
import {ChatMessageFormat} from "@sap/cpaas-commlib-lib";
import {T} from "inferno-i18next";
import {Bundle} from "../../../../services/translationProvider";

export type Props = { messages: IChatMessage[] };
export type State = { url: string };


export default class TranscriptSave extends Component<Props, State> {
	
	state: State = {		
        url: ""
	};

	constructor(props: any) {
		super(props);
	}

	messageContent(message: IChatMessage, title: string) {
		let resMessage: any = "";
		resMessage += title + (message.timestamp && message.timestamp !== undefined ? ' [' + message.timestamp  + ']: ' : ': ');
		if (message.format === ChatMessageFormat.text) {
			const el = document.createElement('div');
			el.innerHTML = message.content;
			resMessage += el.innerText;
		} else if (message.format === ChatMessageFormat.template) {
			resMessage +=  message.content.template.response && message.content.template.response !== undefined ? message.content.template.response : "";
		}
		resMessage += '\n';

		return resMessage;
	}

	componentWillMount() {
		let transcriptBody: any = "";
		this.props.messages.map((message: IChatMessage) => {
			if (message.content) {
				switch (message.entity) {
					case Entity.visitor:
						if (message.hidden !== true) {
							transcriptBody += this.messageContent(message, Bundle.t("VCC_XTIT_TRANSCRIPT_VISITOR"));
						}
						break;
					case Entity.agent:
						if (message.hidden !== true) {
							transcriptBody += this.messageContent(message, Bundle.t("VCC_XTIT_TRANSCRIPT_AGENT"));
						}
						break;
					case Entity.system:
						transcriptBody += Bundle.t("VCC_XTIT_TRANSCRIPT_SYSTEM") + ': ' + message.content + '\n';
						break;
					case Entity.notification:
						transcriptBody += '<<' + message.content + '>>' + '\n';
						break;
					case Entity.unknown:
					default:
				}
			}
		});
        const data = new Blob([transcriptBody], {type: 'text/plain'});
		
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveBlob(data, 'chatTranscript');
			this.state.url = '';
		} else {
			const url = window.URL.createObjectURL(data);
			this.state.url = url;
		}
	}

	componentWillUnmount() {
        // remove the generated URLs
        window.URL.revokeObjectURL(this.state.url);
	}

	render() {
        
		return (
            <Button color="primary" href={this.state.url} download="chatTranscript" className="btn-sm">
                <T i18nKey="VCC_XBUT_CHAT_BUTTON_SAVE_TRANSCRIPT">X</T>
            </Button>
		);
	}
}